<template>
  <div>
    <b-dropdown
      class="float-right"
      variant="link"
      toggle-class="text-decoration-none"
      no-caret
      right
    >
      <template #button-content>
        <span class="svg-icon svg-icon-lg">
          <inline-svg src="media/svg/icons/General/Menu.svg" />
        </span>
      </template>
      <b-dropdown-item @click="CSV()">CSV</b-dropdown-item>
      <b-dropdown-item @click="saveImg()">PNG</b-dropdown-item>
    </b-dropdown>
    <br /><br /><br />
    <v-chart class="chart" :option="option" />
  </div>
</template>

<script>
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { BarChart } from "echarts/charts";
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent
} from "echarts/components";
import VChart, { THEME_KEY } from "vue-echarts";

import "echarts/lib/component/grid";

use([
  CanvasRenderer,
  BarChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent
]);

export default {
  name: "RegPerDayLineChart",
  components: {
    VChart
  },
  provide: {
    [THEME_KEY]: "light"
  },
  props: ["data"],
  data() {
    return {
      option: {
        // title: {
        // text: `${this.$t("PAGE.DASHBOARD.AMOUNT_OF_WASTE_TITLE")}`,
        // left: "center"
        // },
        tooltip: {
          trigger: "item",
          formatter: (params) => {
            let shortMonths = [
              "ม.ค.",
              "ก.พ.",
              "มี.ค.",
              "เม.ย.",
              "พ.ค.",
              "มิ.ย.",
              "ก.ค.",
              "ส.ค.",
              "ก.ย.",
              "ต.ค.",
              "พ.ย.",
              "ธ.ค."
            ];
            let newDate = new Date(params.name);
            let dateStr = `${newDate.getDate()} ${
              shortMonths[newDate.getMonth()]
            } ${newDate.getFullYear()}`;
            return `
              ${dateStr}</br>
              ${params.seriesName} : ${params.value}`;
          }
        },
        legend: {
          bottom: "bottom",
          type: "scroll",
          height: "200"
        },
        grid: {
          left: "15%",
          right: "15%",
          bottom: "20%",
          containLabel: false
        },
        xAxis: [
          {
            name: `${this.$t(
              "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_DASHBOARD.REG_PER_DAY_LINE_X"
            )}`,
            type: "category",
            data: [],
            axisLabel: {
              formatter: function (value) {
                let shortMonths = [
                  "ม.ค.",
                  "ก.พ.",
                  "มี.ค.",
                  "เม.ย.",
                  "พ.ค.",
                  "มิ.ย.",
                  "ก.ค.",
                  "ส.ค.",
                  "ก.ย.",
                  "ต.ค.",
                  "พ.ย.",
                  "ธ.ค."
                ];
                let newDate = new Date(value);
                return `${newDate.getDate()} ${
                  shortMonths[newDate.getMonth()]
                } ${newDate.getFullYear()}`;
              },
              rotate: 60
            }
          }
        ],
        yAxis: [
          {
            name: `${this.$t(
              "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_DASHBOARD.REG_PER_DAY_LINE_Y"
            )}`,
            type: "value"
          }
        ],
        series: [],
        color: ["#008ffb"],
        backgroundColor: "white"
      }
    };
  },
  mounted() {
    if (this.data) {
      let seriesData = [];
      for (let index = 0; index < this.data.series.length; index++) {
        const element = this.data.series[index];
        seriesData.push({
          name: element.name,
          type: "bar",
          stack: "stack",
          emphasis: {
            focus: "series"
          },
          data: element.data
        });
      }
      this.option.xAxis[0].data = this.data.categories;
      this.option.series = seriesData;
    }
  },
  methods: {
    CSV() {
      let headers = [
        `${this.$t(
          "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_DASHBOARD.REG_PER_DAY_LINE_X"
        )}`
      ];

      for (let index = 0; index < this.data.series.length; index++) {
        const element = this.data.series[index];
        headers.push(element.name);
      }

      let contents = [];
      for (let index = 0; index < this.data.categories.length; index++) {
        const element = this.data.categories[index];
        let newDate = new Date(element);
        contents.push([
          `${newDate.getDate()}/${
            newDate.getMonth() + 1
          }/${newDate.getFullYear()}`
        ]);
      }

      for (let index = 0; index < this.data.series.length; index++) {
        const element = this.data.series[index];
        for (let index2 = 0; index2 < element.data.length; index2++) {
          const element2 = element.data[index2];
          contents[index2].push(element2);
        }
      }

      // prepare CSV data
      let csvData = [];
      csvData.push(headers);
      for (let index = 0; index < contents.length; index++) {
        const element = contents[index];
        csvData.push(element);
      }

      let lineArray = [];
      csvData.forEach(function (infoArray, index) {
        let line = infoArray.join(",");
        lineArray.push(index == 0 ? "\uFEFF" + line : line);
      });
      let csvContent = lineArray.join("\n");

      // download stuff
      let blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      let link = document.createElement("a");

      if (link.download !== undefined) {
        // feature detection
        // Browsers that support HTML5 download attribute
        link.setAttribute("href", window.URL.createObjectURL(blob));
        link.setAttribute(
          "download",
          `${this.$t(
            "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_DASHBOARD.REG_PER_DAY_LINE_Y"
          )}.csv`
        );
        link.setAttribute("hidden", true);
      } else {
        // it needs to implement server side export
        link.setAttribute("href", "#");
      }
      link.click();
    },
    saveImg() {
      let canvas = document.getElementsByTagName("canvas");
      if (canvas && canvas.length > 0) {
        // create label
        let tempA = document.createElement("a");
        // Set download name
        tempA.download = `${this.$t(
          "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.TAB_DASHBOARD.REG_PER_DAY_LINE_Y"
        )}.png`;
        // Set address and file type
        tempA.href = canvas[0].toDataURL("image/png");
        document.body.appendChild(tempA);
        // Trigger download event
        tempA.click();
        // Remove Tag
        tempA.remove();
      }
    }
  }
};
</script>

<style scoped>
.chart {
  height: 600px;
}
</style>

<style>
body {
  margin: 0;
}
</style>